export const dealerOnConnectSchema = {
  type: "object",
  properties: {
    password: { type: "string", title: "Password" },
  },
  required: ["password"]
};

export const dealerOnConnectUiSchema = {
  type: "VerticalLayout",
  elements: [
    { type: "Control", scope: "#/properties/password", options: { format: "password" } }
  ]
};

export const dealerOnDetailsSchema = {
  type: "object",
  properties: {
    name: { type: "string", title: "Name" },
    email: { type: "string", title: "Email" },
    domain: { type: "string", title: "Domain URL" },
    dealerOnId: { type: "string", title: "DealerOn ID" },
    type: {
      type: "string",
      title: "Type",
      enum: ["Percentage", "Absolute"]
    },
    amount: { type: "string", title: "Amount" }
  },
  required: ["domain", "dealerOnId", "type", "amount"]
};

export const dealerOnDetailsUiSchema = {
  type: "VerticalLayout",
  elements: [
    { type: "Control", scope: "#/properties/name", options: { readonly: true } },
    { type: "Control", scope: "#/properties/email", options: { readonly: true } },
    { type: "Control", scope: "#/properties/domain" },
    { type: "Control", scope: "#/properties/dealerOnId" },
    { type: "Control", scope: "#/properties/type" },
    { type: "Control", scope: "#/properties/amount" }
  ]
};